var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CanvasStage',{attrs:{"config":{ width: 800, height: 400 }}},[_c('CanvasLayer',[_c('CanvasShape',{attrs:{"config":{
        sceneFunc: function (context, shape) {
          context.beginPath();
          context.moveTo(_vm.x - 25, _vm.y - 25);
          context.lineTo(_vm.x + 25, _vm.y + 25);
          context.moveTo(_vm.x + 25, _vm.y - 25);
          context.lineTo(_vm.x - 25, _vm.y + 25);
          context.closePath();

          context.strokeShape(shape);
        },
        strokeWidth: 1,
        stroke: 'black'
      }}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }